import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "mt-8 md:mt-4" }
const _hoisted_3 = { class: "text-3xl font-medium" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "w-full mt-6 overflow-x-auto" }
const _hoisted_6 = { class: "w-full table-auto" }
const _hoisted_7 = { class: "font-bold text-left border-b-2 border-black" }
const _hoisted_8 = {
  scope: "col",
  class: "px-2 py-2 capitalize"
}
const _hoisted_9 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_10 = { class: "px-2 py-3 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_11 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }

import { ref } from "vue";
import { useRoute } from "vue-router";

import RouterButton from "@/components/RouterButton.vue";
import SortableTableHeader from "@/components/tables/SortableTableHeader.vue";
import PaginationBar from "@/components/PaginationBar.vue";
import ExternalLink from "@/components/ExternalLink.vue";

import api from "@/api/api";
import { PaginationMeta } from "@/types";
import { useFilters } from "@/composables/filters";
import { useUserStore } from "@/store";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'SatifactionSurveyUserList',
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();

const { user } = storeToRefs(useUserStore());
const { filters, sortBy, getFiltersFromQuery, setFilterNoRefresh } = useFilters(route);

const satisfactionTotal = ref(0);
const trainers = ref([]);
const meta = ref({} as PaginationMeta);

const url = `${process.env.VUE_APP_WEBSITE_URL}/howto`;

async function getSatisfaction() {
  getFiltersFromQuery();
  const res = await api.surveys.getSurveySatifaction();
  satisfactionTotal.value = res?.data?.overallScore;
  const response = await api.surveys.getSurveySatifactionTrainers(filters.value);
  meta.value = response.meta;

  trainers.value = await response?.data?.trainers;
}

if (!route.query.page) setFilterNoRefresh("page", "1");

if (!user.value.has_smartsurvey_access) {
  window.location.href = "/dashboard";
}

;(
  ([__temp,__restore] = _withAsyncContext(() => getSatisfaction())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(RouterButton, {
        type: "primary",
        to: { path: `/dashboard` }
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("back-to")) + " " + _toDisplayString(_ctx.$t("dashboard")), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("average-course-satisfaction")) + ": " + _toDisplayString(satisfactionTotal.value), 1),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(ExternalLink, {
          type: "text",
          label: _ctx.$t('what-does-this-mean'),
          href: url,
          capitalize: false
        }, null, 8, ["label"])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("table", _hoisted_6, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", _hoisted_7, [
            _createElementVNode("th", _hoisted_8, [
              _createTextVNode(_toDisplayString(_ctx.$t("trainer")) + " ", 1),
              _createVNode(SortableTableHeader, {
                column: "last_name",
                onSort: _unref(sortBy)
              }, null, 8, ["onSort"])
            ]),
            _createElementVNode("th", _hoisted_9, [
              _createTextVNode(_toDisplayString(_ctx.$t("average-course-satisfaction")) + " ", 1),
              _createVNode(SortableTableHeader, {
                column: "average_satisfaction_score",
                onSort: _unref(sortBy)
              }, null, 8, ["onSort"])
            ])
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(trainers.value, (trainer) => {
            return (_openBlock(), _createElementBlock("tr", {
              class: "border-b border-gray-400 divide-x divide-gray-300 even:bg-play-gray",
              key: trainer.id
            }, [
              _createElementVNode("td", _hoisted_10, _toDisplayString(trainer.name), 1),
              _createElementVNode("td", _hoisted_11, _toDisplayString(trainer.average_satisfaction_score) + "%", 1)
            ]))
          }), 128))
        ])
      ])
    ]),
    _createVNode(PaginationBar, { meta: meta.value }, null, 8, ["meta"])
  ], 64))
}
}

})